<script>
    export let checked = false;
    export let color = "#2196F3";

    let switchId = '_' + Math.random().toString(36).substr(2, 9);
</script>

<div class="checkbox checkbox-info w-100">
    <input type="checkbox" id="{switchId}" bind:checked>
    <label for="{switchId}">
        <span></span>
    </label>
</div>